const About = () => {
  return (
    <div className="about">
      <h4>Version 1.0.0</h4>
    </div>
  );
};

export default About;
